import React, { ReactNode, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useIsSM } from '../../utils/useResponsive';
import { MdClose } from 'react-icons/md';

export default function Modal(props: {
    show: boolean;
    onClose: () => void;
    children: ReactNode;
    className?: string;
    width: number;
    showClose?: boolean;
    notChangeOverflow?: boolean;
}) {
    const isSm = useIsSM();
    const modalID = Math.random().toString(16).slice(2);
    useEffect(() => {
        if (props.notChangeOverflow) return;
        if (props.show) {
            document.body.style.overflow = 'hidden';
        } else if (!props.show) {
            document.body.style.overflow = 'auto';
        }
    }, [props.show]);

    function closeModal() {
        props.onClose();
    }

    const modalWindow = useDetectClickOutside({
        onTriggered: (e) => {
            console.log((e.target as HTMLDivElement).id);
            if ((e.target as HTMLDivElement).id === `modal-bg-${modalID}`) closeModal();
        },
    });

    return (
        <AnimatePresence>
            {props.show && (
                <div
                    id={`modal-bg-${modalID}`}
                    className={`fixed inset-0 z-50 flex h-screen w-screen overflow-y-auto bg-black/40 py-24 sm:px-8 sm:py-5 ${props.className}`}>
                    <motion.div
                        className={`ml-auto mr-auto mt-auto mb-auto rounded-xl bg-white px-2 py-0.5`}
                        style={{
                            width: isSm ? props.width : '100vw',
                        }}
                        ref={modalWindow}
                        initial={{ y: '-50px', opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: '-50px', opacity: 0 }}
                        transition={{ duration: 0.2 }}>
                        {props.showClose ? (
                            isSm ? (
                                <div className={'flex h-0 w-full'}>
                                    <button
                                        onClick={closeModal}
                                        className={
                                            ' group ml-auto flex h-9  w-9 -translate-y-3 translate-x-4 items-center justify-center rounded-full border bg-white '
                                        }>
                                        <MdClose
                                            className={
                                                'text-xl text-black/70 group-hover:text-black/30'
                                            }
                                        />
                                    </button>
                                </div>
                            ) : (
                                <div className={'flex h-0 w-full'}>
                                    <button
                                        onClick={closeModal}
                                        className={
                                            'group ml-auto flex  w-fit translate-y-5 items-center justify-center'
                                        }>
                                        <MdClose
                                            className={
                                                'text-xl text-black/70 group-hover:text-black/30'
                                            }
                                        />
                                    </button>
                                </div>
                            )
                        ) : null}

                        {props.children}
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
}
